import type { AppAction } from '../../types/app.types';
import type { V2BlinkCard } from '../../types/api-v2.types';

export type BlinkCardState = V2BlinkCard & {
  firstName: string | null | undefined;
  lastName: string | null | undefined;
};

const DEFAULT_STATE: BlinkCardState = {
  cardholderId: null,
  company: null,
  firstName: null,
  lastName: null,
  patientHelpNumber: null,
  pharmacyHelpNumber: null,
  rxAmountOwed: null,
  rxBin: null,
  rxGroup: null,
  rxPcn: null,
  status: null,
};
export default function blinkCardReducer(
  state: BlinkCardState = { ...DEFAULT_STATE },
  action: AppAction
): BlinkCardState {
  switch (action.type) {
    case 'account/GET_SUMMARY_SUCCESS': {
      return {
        firstName: action.data.account?.firstName || '',
        lastName: action.data.account?.lastName || '',
        ...action.data.blinkCard,
      };
    }

    default:
      return state;
  }
}
